import React from "react";
import { connect } from "react-redux";
import {
  cargarImagen,
  crearNuevoProveedor,
  editarProveedor,
  subirImagen,
} from "./ProveedorFirmaService";
import Resizer from "react-image-file-resizer";
import { Container, Form, Modal, Row, Col, Button } from "react-bootstrap";
import { logout } from "../login/SesionService";
import { psa } from "../../constans/constants";
import { validateForm } from "../../constans/validationUtils";

class ProveedorFirma extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      clientSecret: "",
      clientId: "",
      schema: "",
      host: "",
      port: "",
      activo: "",
      codigoCliente: "",
      mostrarMensaje: false,
      mensaje: "",
      logo: null,
      urlLogo: "",
      openPantallaCarga: false,
      validated: false,
      errors: {
        clientSecret: null,
        clientId: null,
        schema: null,
        host: null,
        port: null,
        codigoCliente: null,
        descripcion: null,
      },
    };
  }

  reglasValidacionCampos = {
    clientSecret: [
      { required: true, message: 'Campo obligatorio' }
    ],
    clientId: [
      { required: true, message: 'Campo obligatorio' }
    ],
    schema: [
      { required: true, message: 'Campo obligatorio' },
    ],
    host: [
      { required: true, message: 'Campo obligatorio' },
    ],
    port: [
      { required: true, message: 'Campo obligatorio' },
    ],
    codigoCliente: [
      { required: true, message: 'Campo obligatorio' },
    ],
    descripcion: [
      { required: true, message: 'Campo obligatorio' }
    ]
  }


  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensaje: false,
    });
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  };

  handleClose = () => {
    this.props.handleClose(false);
  };

  handleUploadLogo = (event) => {
    try {
      Resizer.imageFileResizer(
        event.target.files[0],
        250,
        200,
        "PNG",
        0,
        0,
        (uri) => {
          this.setState({
            urlLogo: URL.createObjectURL(uri),
            logo: uri,
          });
        },
        "file"
      );
    } catch (error) {
      this.setState({
        mensaje: "Hubo un problema al cargar el nuevo logo",
        mostrarMensaje: true,
      });
    }
  };


  handleProveedorSubmit = (e) => {
    e.preventDefault();
    let { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    if (!isValid) {
      this.setState({errors: errors})
    } else {
      this.setState({ openPantallaCarga: true, validated: true });
      const data = {
        id: this.state.id,
        clientSecret: this.state.clientSecret,
        clientId: this.state.clientId,
        schema: this.state.schema,
        host: this.state.host,
        port: this.state.port,
        activo: this.state.activo,
        descripcion: this.state.descripcion,
        codigoCliente: this.state.codigoCliente,
      };
      if (this.props.type === "edit") {
        editarProveedor(data).then((response) => {
          if (response.error === true) {
            this.setState({
              mensaje: response.mensaje,
              mostrarMensaje: true,
              openPantallaCarga: false,
            });
          } else {
            if (this.state.logo != null) {
              var id = response.datos.id;
              var formData = new FormData();
              formData.append("file", this.state.logo);
              subirImagen(id, formData);
            }
            this.props.handleClose(false, response.mensaje);
          }
        });
      } else if (this.props.type === "add") {
        crearNuevoProveedor(data).then(
          (response) => {
            if (response.error === true) {
              this.setState({
                mostrarMensaje: true,
                mensaje: response.mensaje,
                openPantallaCarga: false,
              });
            } else {
              if (this.state.logo != null) {
                var id = response.datos.id;
                var formData = new FormData();
                formData.append("file", this.state.logo);
                subirImagen(id, formData);
              }
              this.props.handleClose(false, response.mensaje);
            }
          },
          (error) => {
            if (error.response.status === 401) {
              logout();
            }
            return error;
          }
        );
      }
    }
  };

  componentDidMount() {
    this.setState({
      id: this.props.proveedor.id,
      clientSecret: this.props.proveedor.clientSecret,
      clientId: this.props.proveedor.clientId,
      descripcion: this.props.proveedor.descripcion,
      schema: this.props.proveedor.schema,
      host: this.props.proveedor.host,
      port: this.props.proveedor.port,
      activo: this.props.proveedor.activo,
      codigoCliente: this.props.proveedor.codigoCliente,
    });
    if (this.props.type === "edit") {
      cargarImagen(this.props.proveedor.id).then(
        (res) => {
          if (res != null) {
            this.setState({
              urlLogo: "data:image/png;base64," + res,
            });
          }
        },
        (error) => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        }
      );
    }
  }
  chkclick = (event) => {
    let rolesxempresa = this.state.rolesxempresa;
    rolesxempresa[this.state.empresaSelect].roles.forEach((elemento) => {
      if (elemento.id == event.target.value) {
        elemento.checked = event.target.checked;
      }
    });
    this.setState({ rolesxempresa: rolesxempresa });

    let rolesSelect = this.state.rolesSelect;
    rolesSelect.roles.forEach((elemento) => {
      if (elemento.id == event.target.value) {
        elemento.checked = event.target.checked;
      }
    });
    this.setState({ rolesSelect: rolesSelect });
  };

  render() {
    return (
      <Container>
        <Form
          noValidate
          onSubmit={this.handleProveedorSubmit}
        >
          <Modal.Header>
            <Modal.Title style={{ color: "#0c56d0" }}>
              {" "}
              {this.props.dialogTitle}{" "}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group
                    className="form-group md-input"
                    style={{ marginBottom: "35px" }}
                  >
                    <Form.Control
                      className="form-control md-form-control"
                      type="text"
                      name="clientId"
                      required
                      isInvalid = {!!this.state.errors.clientId}
                      onChange={this.handleInput}
                      value={this.state.clientId}
                    />
                    <Form.Label class="md-label">Client ID</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      <p>
                        <small>{this.state.errors.clientId}</small>
                      </p>
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group
                    className="form-group md-input"
                    style={{ marginBottom: "35px" }}
                  >
                    <Form.Control
                      className="form-control md-form-control"
                      type="text"
                      name="clientSecret"
                      required
                      isInvalid={!!this.state.errors.clientSecret}   
                      onChange={this.handleInput}
                      value={this.state.clientSecret}
                    />
                    <Form.Label class="md-label"> Client secret </Form.Label>
                    <Form.Control.Feedback type="invalid">
                      <p>
                        <small>{this.state.errors.clientSecret}</small>
                      </p>
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group
                    className="form-group md-input"
                    style={{ marginBottom: "35px" }}
                  >
                    <Form.Control
                      className="form-control md-form-control"
                      type="text"
                      name="descripcion"
                      required
                      isInvalid={!!this.state.errors.descripcion}
                      onChange={this.handleInput}
                      value={this.state.descripcion}
                    />
                    <Form.Label class="md-label"> Descripcion </Form.Label>
                    <Form.Control.Feedback type="invalid">
                      <p>
                        <small>{this.state.errors.descripcion}</small>
                      </p>
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="form-group md-input">
                    <Form.Label>
                      <p className="form-date">
                        <strong>Logo del proveedor</strong>
                      </p>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      onChange={this.handleUploadLogo}
                      accept="images/*"
                    />
                  </Form.Group>
                  <img
                    id="logoProveedorImage"
                    src={this.state.urlLogo}
                    accept="image/png, image/jpeg"
                    style={{ marginTop: "5px" }}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group
                    className="form-group md-input"
                    style={{ marginBottom: "35px" }}
                  >
                    <Form.Control
                      className="form-control md-form-control"
                      type="text"
                      name="schema"
                      required
                      isInvalid={!!this.state.errors.schema}
                      onChange={this.handleInput}
                      value={this.state.schema}
                    />
                    <Form.Label class="md-label"> Esquema </Form.Label>
                    <Form.Control.Feedback type="invalid">
                      <p>
                        <small>{this.state.errors.schema}</small>
                      </p>
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group
                    className="form-group md-input"
                    style={{ marginBottom: "35px" }}
                  >
                    <Form.Control
                      className="form-control md-form-control"
                      type="text"
                      name="host"
                      required
                      isInvalid={!!this.state.errors.host}
                      onChange={this.handleInput}
                      value={this.state.host}
                    />
                    <Form.Label class="md-label"> Host </Form.Label>
                    <Form.Control.Feedback type="invalid">
                      <p>
                        <small>{this.state.errors.host}</small>
                      </p>
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group
                    className="form-group md-input"
                    style={{ marginBottom: "35px" }}
                  >
                    <Form.Control
                      className="form-control md-form-control"
                      type="text"
                      name="port"
                      required
                      isInvalid={!!this.state.errors.port}
                      onChange={this.handleInput}
                      value={this.state.port}
                    />
                    <Form.Label class="md-label">Puerto</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      <p>
                        <small>{this.state.errors.port}</small>
                      </p>
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group
                    className="form-group md-input"
                    style={{ marginBottom: "20px" }}
                  >
                    <Form.Select
                      className="form-control md-select"
                      name="codigoCliente"
                      onChange={this.handleInput}
                      value={this.state.codigoCliente}
                      isInvalid={!!this.state.errors.codigoCliente}
                      required
                    >
                      <option key="" value="" selected></option>
                      {psa.map((elemento) => (
                        <option key={elemento.codigo} value={elemento.codigo}>
                          {elemento.nombre}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Label class="md-label"> Cliente </Form.Label>
                    <Form.Control.Feedback type="invalid">
                        <p><small>{this.state.errors.codigoCliente}</small></p>
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group
                    className="form-group md-input"
                    style={{ marginBottom: "35px" }}
                  >
                    <Form.Check
                      type="switch"
                      id="estadoEmpresa"
                      checked={this.state.activo}
                      onChange={this.handleChange}
                      name="activo"
                      label="Activo"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose} variant="contained">
              Cancelar
            </Button>
            <Button autoFocus color="primary" type="submit">
              {this.props.submitText}
            </Button>
          </Modal.Footer>
        </Form>
      </Container>
    );
  }
}

export default ProveedorFirma;
